const config = {
    // Base URL for API Gateway
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://54.87.140.133",
    // Base URL for S3 Bucket
    s3BaseUrl: process.env.REACT_APP_S3_BASE_URL || "https://your-s3-bucket.s3.amazonaws.com",
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
};

export default config;